(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('invoice-patient', {
            parent: 'invoice-detail',
            url: '/invoice-patient',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Invoice Patients'
            },
            ncyBreadcrumb: {
                label: 'Invoice Patients',
                parent: 'invoice'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice-patient/invoice-patients.html',
                    controller: 'InvoicePatientController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('invoice-patient-detail', {
            parent: 'entity',
            url: '/invoice-patient/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'InvoicePatient'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice-patient/invoice-patient-detail.html',
                    controller: 'InvoicePatientDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'InvoicePatient', function($stateParams, InvoicePatient) {
                    return InvoicePatient.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'invoice-patient',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('invoice-patient-detail.edit', {
            parent: 'invoice-patient-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice-patient/invoice-patient-dialog.html',
                    controller: 'InvoicePatientDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InvoicePatient', function(InvoicePatient) {
                            return InvoicePatient.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('invoice-patient.edit', {
            parent: 'invoice-patient',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice-patient/invoice-patient-dialog.html',
                    controller: 'InvoicePatientDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InvoicePatient', function(InvoicePatient) {
                            return InvoicePatient.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('invoice-patient', null, { reload: 'invoice-patient' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
    }
})();
